export const SET_EXT_ERRORS = "SET_EXT_ERRORS";
export const SET_QB_ERRORS = "SET_QB_ERRORS";
export const SET_FILTERS = "SET_FILTERS";
export const SET_FULL_DATA_FILTERS = "SET_FULL_DATA_FILTERS";

export const SET_EXT_LOADING = "SET_EXT_LOADING";
export const SET_FULL_DATA_LOADING = "SET_FULL_DATA_LOADING";
export const SET_FULL_DATA_PAGINATION_LOADING = "SET_FULL_DATA_PAGINATION_LOADING";
export const SET_PAGE_LOAD_DATA_LOADING = "SET_PAGE_LOAD_DATA_LOADING";

export const SET_VIEW_DATA = "SET_VIEW_DATA";
export const SET_VIEW_MODE = "SET_VIEW_MODE";
export const RESET_FORM = "RESET_FORM";

export const LOAD_EXT_PAGE_DATA = "LOAD_EXT_PAGE_DATA";
export const LOAD_EXT_PAGE_DATA_SUCCESS = "LOAD_EXT_PAGE_DATA_SUCCESS";
export const LOAD_EXT_PAGE_DATA_FAILURE = "LOAD_EXT_PAGE_DATA_FAILURE";

export const SET_STEP_VAL = "SET_STEP_VAL";
export const SET_EXTRACTION_DATA = "SET_EXTRACTION_DATA";

export const GET_EXTRACTIONS = "GET_EXTRACTIONS";
export const GET_EXTRACTIONS_SUCCESS = "GET_EXTRACTIONS_SUCCESS";
export const GET_EXTRACTIONS_FAILURE = "GET_EXTRACTIONS_FAILURE";

export const CREATE_EXTRACTION = "CREATE_EXTRACTION";
export const CREATE_EXTRACTION_SUCCESS = "CREATE_EXTRACTION_SUCCESS";
export const CREATE_EXTRACTION_FAILURE = "CREATE_EXTRACTION_FAILURE";

export const UPDATE_EXTRACTION = "UPDATE_EXTRACTION";
export const UPDATE_EXTRACTION_SUCCESS = "UPDATE_EXTRACTION_SUCCESS";
export const UPDATE_EXTRACTION_FAILURE = "UPDATE_EXTRACTION_FAILURE";

export const GET_COLUMN_LIST_VALUES = "GET_COLUMN_LIST_VALUES";
export const GET_COLUMN_LIST_VALUES_SUCCESS = "GET_COLUMN_LIST_VALUES_SUCCESS";
export const GET_COLUMN_LIST_VALUES_FAILURE = "GET_COLUMN_LIST_VALUES_FAILURE";

export const LOAD_EXTRACTION = "LOAD_EXTRACTION";
export const LOAD_EXTRACTION_SUCCESS = "LOAD_EXTRACTION_SUCCESS";
export const LOAD_EXTRACTION_FAILURE = "LOAD_EXTRACTION_FAILURE";

export const GET_FIELD_VALUE_OPTIONS = "GET_FIELD_VALUE_OPTIONS";
export const GET_FIELD_VALUE_OPTIONS_SUCCESS = "GET_FIELD_VALUE_OPTIONS_SUCCESS";
export const GET_FIELD_VALUE_OPTIONS_FAILURE = "GET_FIELD_VALUE_OPTIONS_FAILURE";

export const GET_FIELD_VALUE_OPTIONS_LOADING = "GET_FIELD_VALUE_OPTIONS_LOADING";

export const RESET_QUERY_BUILDER = "RESET_QUERY_BUILDER";

export const GET_PROJECTS_FOR_MASTER = "GET_PROJECTS_FOR_MASTER";
export const GET_EXT_PROJECTS_FOR_MASTER = "GET_EXT_PROJECTS_FOR_MASTER";
export const GET_PROJECTS_FOR_MASTER_SUCCESS = "GET_PROJECTS_FOR_MASTER_SUCCESS";
export const GET_PROJECTS_FOR_MASTER_FAILURE = "GET_PROJECTS_FOR_MASTER_FAILURE";
export const GET_EXT_PROJECTS_FOR_MASTER_LOADING = "GET_EXT_PROJECTS_FOR_MASTER_LOADING";
export const GET_EXT_META_DATA_LOADING = "GET_EXT_META_DATA_LOADING";

export const NEXT_WORKFLOW_STEP = "NEXT_WORKFLOW_STEP";
export const NEXT_WORKFLOW_STEP_SUCCESS = "NEXT_WORKFLOW_STEP_SUCCESS";
export const NEXT_WORKFLOW_STEP_FAILURE = "NEXT_WORKFLOW_STEP_FAILURE";

export const MOVE_TO_STEP3 = "MOVE_TO_STEP3";
export const MOVE_TO_STEP3_SUCCESS = "MOVE_TO_STEP3_SUCCESS";
export const MOVE_TO_STEP3_FAILURE = "MOVE_TO_STEP3_FAILURE";

export const LOAD_CUSTOM_COLUMN_OPTIONS = "LOAD_CUSTOM_COLUMN_OPTIONS";
export const LOAD_CUSTOM_COLUMN_OPTIONS_SUCCESS = "LOAD_CUSTOM_COLUMN_OPTIONS_SUCCESS";
export const LOAD_CUSTOM_COLUMN_OPTIONS_FAILURE = "LOAD_CUSTOM_COLUMN_OPTIONS_FAILURE";

export const VIEW_FULL_DATA = "VIEW_FULL_DATA";
export const VIEW_FULL_DATA_SUCCESS = "VIEW_FULL_DATA_SUCCESS";
export const VIEW_FULL_DATA_FAILURE = "VIEW_FULL_DATA_FAILURE";

export const SET_SELECTED_VERSION = "SET_SELECTED_VERSION";
export const SET_SELECTED_VERSION_SUCCESS = "SET_SELECTED_VERSION_SUCCESS";
export const SET_SELECTED_VERSION_FAILURE = "SET_SELECTED_VERSION_FAILURE";

export const SAVE_TEMP_SELECTIONS = "SAVE_TEMP_SELECTIONS";

export const SET_INGESTION_PROGRESS = "SET_INGESTION_PROGRESS";
export const POLL_INGESTION_PROGRESS = "POLL_INGESTION_PROGRESS";
export const START_SHOW_FULL_DATA = "START_SHOW_FULL_DATA";

export const SET_PAGE_LOAD_PROJECTS = "SET_PAGE_LOAD_PROJECTS";

export const GET_EXT_META_DATA = "GET_EXT_META_DATA";
export const GET_EXT_META_DATA_SUCCESS = "GET_EXT_META_DATA_SUCCESS";
export const GET_EXT_META_DATA_FAILURE = "GET_EXT_META_DATA_FAILURE";

export const GET_EXT_PINCODE_FROM_MASTER = "GET_EXT_PINCODE_FROM_MASTER";
export const GET_EXT_PINCODE_FROM_MASTER_LOADING = "GET_EXT_PINCODE_FROM_MASTER_LOADING";
export const GET_EXT_PINCODE_FROM_MASTER_SUCCESS = "GET_EXT_PINCODE_FROM_MASTER_SUCCESS";    
export const GET_EXT_PINCODE_FROM_MASTER_FAILURE = "GET_EXT_PINCODE_FROM_MASTER_FAILURE";
